import { StubScreen } from '../StubScreen';

// Stub (DIT-671). Real content lands in DIT-680/681/682 (2.1–2.3 company).
export const CompanyScreen = () => (
  <StubScreen id="company" heading="Wie heißt Ihr Unternehmen?" />
);
